import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { useTheme, Colors } from '../Themes';

import styles from './styles';

const RadioButton = ({
  selected = null,
  style,
  selectedStyle,
  onPress = () => null,
  testID,
  accessibilityLabel,
  touchableAreaStyle,
  hitSlop,
}) => {
  const theme = useTheme();
  const unSelectedColor = theme.isDark ? Colors.white : Colors.warm_grey_two;

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={selected}
      testID={testID ?? FoundationTestKeys.radioButtonTO}
      accessibilityLabel={accessibilityLabel ?? FoundationTestKeys.radioButtonTO}
      style={touchableAreaStyle}
      hitSlop={hitSlop}
    >
      <View
        style={[
          styles.container(theme),
          !selected ? { borderColor: unSelectedColor } : null,
          style,
        ]}
        testID={FoundationTestKeys.radioButtonView}
      >
        {selected ? (
          <View
            style={[styles.selected(theme), selectedStyle]}
            testID={FoundationTestKeys.radioButtonSelectedView}
          />
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

RadioButton.propTypes = {
  selected: PropTypes.bool,
  style: PropTypes.any,
  selectedStyle: PropTypes.any,
  onPress: PropTypes.func,
  testID: PropTypes.string,
  accessibilityLabel: PropTypes.string,
  touchableAreaStyle: ViewPropTypes.style,
  hitSlop: ViewPropTypes.hitSlop,
};

export default RadioButton;
